export const IP = '\\s+\\(\\d+\\.\\d+\\.\\d+\\.\\d+\\)';
export const NL = '(?:\\sNL)?';
